import axios from 'axios';
import api_url from '../urls';
const actions = {

    addTipo_disciplina (context, value) {

        const USER_TOKEN = localStorage.getItem('access_token');
        const AuthStr = 'Bearer '.concat(USER_TOKEN)
         axios.post(api_url.api_admin + 'v1/admin/tipo-disciplina',
        {
          nome: value.nome,
          empresa_id: 1,
          status: 1
        }
        , {
            headers: {
                'Authorization': AuthStr,
                'Content-Type': 'application/json',
                'X-Requested-With':'XMLHttpRequest',
            }
        })
        .then(response => {
             //console.log(response);
           // context.commit('ADD_TIPO_DISCIPLINA', value)
        })
        .catch((error) => {
            console.log(error);
        });
         //console.log(value)
    },
    allTipo_disciplinas (context, value) {

      const USER_TOKEN = localStorage.getItem('access_token');
      const AuthStr = 'Bearer '.concat(USER_TOKEN)
       axios.get(api_url.api_admin + 'v1/admin/tipo-disciplina',
       {
          headers: {
              'authorization': AuthStr,
              'Accept' : 'application/json',
              'Content-Type': 'application/json'
          }
      })
      .then(response => {
           //console.log(response.data);
          context.commit('ALL_TIPO_DISCIPLINAS', response.data)
      })
      .catch((error) => {
          console.log(error);
      });
      
  }
}

export default actions